/*Состояния*/
const state = () => ({
  activeState: false,
  type: "Fast",
  afterDetailState: false,
});
export { state };
